import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import c from 'classnames';
import styles from './Notification.css';

// https://github.com/yannickcr/eslint-plugin-react/issues/2269
// eslint-disable-next-line react/display-name
export const Notification = forwardRef((props, ref) => {

  const notificationMessages = useRef();

  useImperativeHandle(ref, () => ({

    addNotification(message, type) {
      const newNode = document.createElement('div');

      newNode.className = c(
        styles.notification,
        { [styles.success]: type === 'success' },
        { [styles.error]: type === 'error' },
        { [styles.warning]: type === 'warning' },
        { [styles.info]: type === 'info' },
      );
      newNode.innerHTML = message;

      const parentDiv = notificationMessages.current.parentNode;
      const notification = notificationMessages.current;

      parentDiv.insertBefore(newNode, notification);

      setTimeout(() => {
        newNode.style.transform = 'translateX(0) translateY(0)';
        setTimeout(() => {
          newNode.style.transform = 'translateX(-100%)';
          setTimeout(() => { parentDiv.removeChild(newNode); }, 200);
        }, 3000);        
      }, 100);
    },
  }));

  return (
    <div className={styles.notification_container}>
      <span ref={notificationMessages} className="message" ></span>
    </div>
  );
});
